import { observer } from 'mobx-react-lite';
import { useBlogContext } from '../BlogProvider';
import { useBlogTrans } from '../../blogHooks/useBlogTrans';

export const BlogCategoryBadge = observer(({ category = '' }: { category: string }) => {
    const { lang } = useBlogContext();
    const { trans } = useBlogTrans();

    return (
        <a href={`/${lang}/post/${category}`} className="badge badge-soft badge-sm">
            {trans(category as keyof typeof trans)}
        </a>
    );
});
